export const CONTENT_ROUTE_DATA = {
    CONTENT: {
        PATH: 'content/:contentId',
        PAGE: 'Content',
    },
};
